<template>
	<div class="d-flex flex-row nowrap align-items-center justify-content-start">
		<div class="col-4 p-0">
			<button
				:disabled="isLeftBtnDisabled && true"
				@click.stop="$emit('minus')"
				class="plusMinusButton ts-minus-blue"
				:class="isLeftBtnDisabled && 'ts-minus-grey'"
			></button>
		</div>
		<div class="col-4 p-0 body text-grey-900 text-center pt-2 ps-1">
			<span>{{ num }}</span>
		</div>
		<div class="col-4 p-0">
			<button
				:disabled="isRightBtnDisabled && true"
				@click.stop="$emit('plus')"
				class="plusMinusButton ts-plus-blue"
				:class="isRightBtnDisabled && 'ts-plus-grey'"
			></button>
		</div>
	</div>
</template>

<script>
import { getCookie } from "@/utils/utils";
import store from "@/vue/planning/store/store";

export default {
	name: "AddRemove",
	props: {
		num: {
			type: Number,
			default: 0,
		},
		btnBackground: {
			type: String,
			default: "",
		},
		btnBorder: {
			type: String,
			default: "#0cb5dc 1px solid",
		},
		btnSize: {
			type: String,
			default: "34px",
		},
		btnColor: {
			type: String,
			default: "",
		},
		btnDisabledBackground: {
			type: String,
			default: "white",
		},
		btnDisabledBorder: {
			type: String,
			default: "lightgray 1px solid",
		},
		btnDisabledSize: {
			type: String,
			default: "34px",
		},
		btnDisabledColor: {
			type: String,
			default: "lightgray",
		},
		minVal: Number,
		maxVal: Number,
	},
	computed: {
		isLeftBtnDisabled() {
			if (this.checkIfCgos()) return true;
			if (this.num === this.minVal) {
				return true;
			}
			return false;
		},
		isRightBtnDisabled() {
			if (this.checkIfCgos()) return true;
			if (this.num === this.maxVal) {
				return true;
			}
			return false;
		},

		btnLeftStyle() {
			if (this.isLeftBtnDisabled) {
				return {
					width: this.btnDisabledSize,
					height: this.btnDisabledSize,
					background: this.btnDisabledBackground,
					border: this.btnDisabledBorder,
					color: this.btnDisabledColor,
				};
			}
			return {
				width: this.btnSize,
				height: this.btnSize,
				background: this.btnBackground,
				border: this.btnBorder,
				color: this.btnColor,
			};
		},
		btnRightStyle() {
			if (this.isRightBtnDisabled) {
				return {
					width: this.btnDisabledSize,
					height: this.btnDisabledSize,
					background: this.btnDisabledBackground,
					border: this.btnDisabledBorder,
					color: this.btnDisabledColor,
				};
			}
			return {
				width: this.btnSize,
				height: this.btnSize,
				background: this.btnBackground,
				border: this.btnBorder,
				color: this.btnColor,
			};
		},
	},

	methods: {
		checkIfCgos() {
			const company = getCookie("company");
			if (store.getters.locale === "fr_FR_CSE" && company === "cgos")
				return true;
		},
	},
};
</script>

<style scoped>
.number {
	min-width: 24px;
}

.plusMinusButton {
	width: 24px;
	height: 24px;
	transition: box-shadow 100ms ease-in-out;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	touch-action: manipulation;
}
</style>
